import React, { useState } from 'react'
export const AlertContext = React.createContext()
export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    severity: '',
    message: '',
    action: false,
  })
  return (
    <AlertContext.Provider value={{ alert, setAlert }}>
      {children}
    </AlertContext.Provider>
  )
}
